module.exports = __webpack_public_path__ + "img/icon-sb-ottoman-recliner.4ca0161.svg";